<template>
  <b-row class="m-0">
    <b-col cols="12" class="p-0">
      <b-media
        left-align
        vertical-align="center"
        class="media m-0 p-3"
        :style="{ background: `#20a8d8` }"
      >
        <template #aside>
          <b-img
            width="80"
            alt="placeholder"
            class="rounded-circle"
            src="https://www.attendit.net/images/easyblog_shared/July_2018/7-4-18/b2ap3_large_totw_network_profile_400.jpg"
          >
          </b-img>
        </template>
        <h5 class="" v-if="personItem">
          <span class="px-1"
            >{{ personItem.name }} {{ personItem.family }}</span
          >
          <span key="fa-star"><i class="fas fa-star"></i></span>
        </h5>
        <b-row>
          <b-col cols="12">
            <span class="px-1"
              ><i class="fas fa-phone px-1"></i> 09301098945</span
            >
            <span class="px-1"
              ><i class="fas fa-envelope px-1"></i> mttinor@gmail.com
            </span>
          </b-col>
          <b-col cols="12">
            <span class="px-1">
              آدرس، آژانس اینترنتی رهن و اجاره آپارتمان در تهران و شهرهای مجاور
              آن است، ما به شما کمک می‌کنیم
            </span>
          </b-col>
          <b-col cols="12" class="mt-2">
            <div class="px-1">
              <b-badge pill variant="secondary" class="mx-2">
                <i class="fas fa-tags"></i> برچسب
              </b-badge>
              <b-badge pill variant="secondary" class="mx-2">
                <i class="fas fa-tags"></i> برچسب
              </b-badge>
              <b-badge pill variant="secondary" class="mx-2">
                <i class="fas fa-tags"></i> برچسب
              </b-badge>
              <b-badge pill variant="secondary" class="mx-2">
                <i class="fas fa-tags"></i> برچسب
              </b-badge>
            </div>
          </b-col>
        </b-row>
      </b-media>
    </b-col>

    <b-col cols="6" class="my-2">
      <b-tabs content-class="mt-3">
        <b-tab title="First" active>
          <p>I'm the first tab</p>
        </b-tab>
        <b-tab title="Second">
          <p>I'm the second tab</p>
        </b-tab>
        <b-tab title="Disabled" disabled>
          <p>I'm a disabled tab!</p>
        </b-tab>
      </b-tabs>
    </b-col>
    <b-col cols="6" class="my-2">
      <b-tabs content-class="mt-3">
        <b-tab title="First" active>
          <p>I'm the first tab</p>
        </b-tab>
        <b-tab title="Second">
          <p>I'm the second tab</p>
        </b-tab>
        <b-tab title="Disabled" disabled>
          <p>I'm a disabled tab!</p>
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import finalReportVotesVue from "@/modules/report/views/finalReport/finalReportVotes.vue";
export default {
  inject: ["profileRepository"],
  props: {
    personCode: {
      type: String,
    },
  },
  data() {
    return {
      personItem: {},
      isLoading: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        this.isLoading = true;
        const response = await this.profileRepository.list(this.personCode);
        const { data } = response.data;
        this.personItem = data;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style>
</style>
